module.exports = __webpack_public_path__ + "svg/shoulders-average.75f5633529c5630802e802dabf37fcc5.svg";